import { DAWType, DAW_EXTENSIONS } from '../../types/daw';

/**
 * Check if a filename is a DAW file by extension
 * @param fileName - The filename to check
 * @returns true if the file has a DAW extension
 */
export function isDAWFile(fileName: string): boolean {
  const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
  return extension in DAW_EXTENSIONS;
}

/**
 * Get DAW type from file extension
 * @param extension - The file extension (with or without dot)
 * @returns The DAW type or 'unknown'
 */
export function getDAWTypeFromExtension(extension: string): DAWType {
  const normalizedExtension = extension.toLowerCase();
  return DAW_EXTENSIONS[normalizedExtension]?.type || DAWType.UNKNOWN;
}

/**
 * Filter to top-level project folders (exclude subfolders of projects)
 * @param foldersWithDAWFiles - Set of all folder paths that contain DAW files
 * @returns Set of top-level project folder paths (no nested projects)
 */
export function filterTopLevelProjectFolders(
  foldersWithDAWFiles: Set<string>
): Set<string> {
  const projectFolders = Array.from(foldersWithDAWFiles).sort(
    (a, b) => a.split('/').length - b.split('/').length
  );
  const topLevelProjects = new Set<string>();

  projectFolders.forEach((folder) => {
    const parts = folder.split('/');
    let hasAncestor = false;
    for (let i = parts.length - 1; i > 0; i--) {
      const ancestor = parts.slice(0, i).join('/');
      if (topLevelProjects.has(ancestor)) {
        hasAncestor = true;
        break;
      }
    }
    if (!hasAncestor) {
      topLevelProjects.add(folder);
    }
  });

  return topLevelProjects;
}
